module.exports = __webpack_public_path__ + "static/media/bilten2.84b482ec.png";